import React, { useState, useEffect, useCallback } from "react";
import { deleteResult, getAllResults } from "../utils/firebase-utils";
import { getColorByPercentage } from "../utils/getColorByPercentage.ts";
import { Player, SavedTournament, StandingsRow } from "../types.ts";
import TournamentDetailModal from "../components/TournamentDetailModal.tsx";
import {
  buildStandings,
  getSeasonTitle,
  sortTournamentsByDateDesc,
} from "../utils/championship.ts";

// Definice typů pro turnaj a výsledky
interface ChampionshipProps {
  players: Player[];
}

const Championship: React.FC<ChampionshipProps> = ({ players }) => {
  // Ročník se řídí posledním odehraným turnajem, ne aktuálním datem
  // Turnaj vybraný kliknutím na datum – zobrazí se jen pro čtení
  const [selectedTournament, setSelectedTournament] =
    useState<SavedTournament | null>(null);
  const [tournaments, setTournaments] = useState<SavedTournament[]>([
    // { id: "1", date: "27.02.", participants: 14 },
    // { id: "2", date: "20.02.", participants: 11 },
    // { id: "3", date: "13.02.", participants: 8 },
    // { id: "4", date: "06.02.", participants: 13 },
    // { id: "5", date: "30.01.", participants: 12 },
    // { id: "6", date: "23.01.", participants: 10 },
    // { id: "7", date: "16.01.", participants: 10 },
  ]);

  const [results, setResults] = useState<StandingsRow[]>([
    // {
    //   playerName: "Keprt",
    //   totalPoints: 72,
    //   results: [11, 10, 5, 10, null, 11, 8],
    //   attendance: 89,
    //   pointsPerVisit: 9.0,
    // },
    // {
    //   playerName: "Vašek",
    //   totalPoints: 70,
    //   results: [10, 8, 3, 8, 9, 9, 9],
    //   attendance: 100,
    //   pointsPerVisit: 7.78,
    // },
    // {
    //   playerName: "Hronek",
    //   totalPoints: 54,
    //   results: [12, 9, null, 12, 11, 10, null],
    //   attendance: 56,
    //   pointsPerVisit: 10.8,
    // },
    // {
    //   playerName: "Jordanov",
    //   totalPoints: 50,
    //   results: [14, 11, null, 13, 12, null, null],
    //   attendance: 44,
    //   pointsPerVisit: 12.5,
    // },
    // {
    //   playerName: "Buček",
    //   totalPoints: 48,
    //   results: [8, 5, 2, 5, 6, 5, 7],
    //   attendance: 100,
    //   pointsPerVisit: 5.33,
    // },
    // {
    //   playerName: "Kropáč",
    //   totalPoints: 43,
    //   results: [7, 4, 1, 2, 10, 6, 10],
    //   attendance: 89,
    //   pointsPerVisit: 5.38,
    // },
    // {
    //   playerName: "Peší",
    //   totalPoints: 42,
    //   results: [5, null, 7, 3, 4, 8, 5],
    //   attendance: 89,
    //   pointsPerVisit: 5.25,
    // },
    // {
    //   playerName: "Mrkos",
    //   totalPoints: 39,
    //   results: [4, 3, 6, 7, 7, 2, 4],
    //   attendance: 89,
    //   pointsPerVisit: 4.88,
    // },
    // {
    //   playerName: "Němec",
    //   totalPoints: 39,
    //   results: [13, null, 8, 11, null, 7, null],
    //   attendance: 44,
    //   pointsPerVisit: 9.75,
    // },
    // {
    //   playerName: "Heneš",
    //   totalPoints: 38,
    //   results: [9, 2, null, 4, 5, 4, 6],
    //   attendance: 89,
    //   pointsPerVisit: 4.75,
    // },
    // {
    //   playerName: "Hrdina",
    //   totalPoints: 28,
    //   results: [3, null, null, 9, 8, null, null],
    //   attendance: 56,
    //   pointsPerVisit: 5.6,
    // },
    // {
    //   playerName: "Adler",
    //   totalPoints: 25,
    //   results: [2, null, 4, 6, 2, 3, 3],
    //   attendance: 78,
    //   pointsPerVisit: 3.57,
    // },
    // {
    //   playerName: "Potůček",
    //   totalPoints: 24,
    //   results: [6, 6, null, null, 3, null, 2],
    //   attendance: 56,
    //   pointsPerVisit: 4.8,
    // },
    // {
    //   playerName: "Sádlík",
    //   totalPoints: 8,
    //   results: [1, 1, null, 1, 1, 1, 1],
    //   attendance: 89,
    //   pointsPerVisit: 1.0,
    // },
    // {
    //   playerName: "Kolařík",
    //   totalPoints: 7,
    //   results: [null, 7, null, null, null, null, null],
    //   attendance: 11,
    //   pointsPerVisit: 7.0,
    // },
  ]);
  const [deletingId, setDeletingId] = useState<string | null>(null);

  const fetchResults = useCallback(async () => {
    try {
      const championship = await getAllResults();
      // Stejný výpočet používá i veřejná stránka – čísla se tak nerozejdou
      const sortedTournaments = sortTournamentsByDateDesc(
        championship as SavedTournament[]
      );

      setTournaments(sortedTournaments);
      setResults(buildStandings(players, sortedTournaments));
    } catch (err) {
      console.error("Chyba při načíteni sampionatu:", err);
    }
  }, [players]);

  useEffect(() => {
    fetchResults();
  }, [fetchResults]);

  /**
   * Smazání turnaje z archivu. Používá se hlavně na odstranění duplicity,
   * která vznikla dvojím uložením – bodu za umístění by se jinak hráčům
   * započítaly dvakrát.
   */
  const handleDeleteTournament = async (tournament: SavedTournament) => {
    const label = `${tournament.date} (${
      tournament.playerCount ?? tournament.player?.length ?? "?"
    } hráčů)`;

    if (
      !window.confirm(
        `Opravdu smazat turnaj ${label}? Tato akce je nevratná a ovlivní ` +
          "průběžné pořadí šampionátu."
      )
    ) {
      return;
    }

    setDeletingId(tournament.id);
    try {
      await deleteResult(tournament.id);

      // Aktuální turnaj si pamatuje, že tohle datum je uložené, a má kvůli
      // tomu zamčené ukládání. Po smazání musí jít uložit znovu.
      if (localStorage.getItem("savedTournamentDate") === tournament.date) {
        localStorage.removeItem("savedTournamentDate");
      }

      setSelectedTournament(null);
      await fetchResults();
    } catch (err) {
      console.error("Chyba při mazání turnaje:", err);
      alert("Turnaj se nepodařilo smazat. Zkontrolujte připojení a oprávnění.");
    } finally {
      setDeletingId(null);
    }
  };

  // Přidání prázdných řádků
  const emptyRows = 0; // Počet prázdných řádků
  useEffect(() => {
    const emptyResult = {
      playerName: "",
      totalPoints: 0,
      results: Array(tournaments.length).fill(null),
      attendance: 0,
      pointsPerVisit: 0,
    };

    const currentEmptyRows = results.filter(
      (r: StandingsRow) => r.playerName === ""
    ).length;
    if (currentEmptyRows < emptyRows) {
      setResults([
        ...results,
        ...Array(emptyRows - currentEmptyRows).fill({ ...emptyResult }),
      ]);
    }
  }, [results, tournaments.length]);

  // Řazení hráčů podle bodů
  const sortedResults = [...results].sort(
    (a, b) => b.placementPoints - a.placementPoints
  );

  const title = getSeasonTitle(tournaments);

  return (
    <div className="max-w-full overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200 border text-sm">
        <thead>
          <tr className="bg-gray-50">
            <th
              className="border bg-gray-50 px-4 py-2 text-left text-gray-500"
              colSpan={2}
            >
              {title}
            </th>
            <th className="border bg-gray-50 px-4 py-2 text-center text-gray-500"></th>
            <th
              className="border bg-gray-50 px-4 py-2 text-right text-gray-500"
              colSpan={12}
            >
              Bodů za návštěvu
            </th>
          </tr>
          <tr>
            <th className="border bg-gray-50 px-4 py-2 text-left"></th>
            <th className="border bg-gray-50 px-4 py-2 text-center">CELKEM</th>
            {Array(10)
              .fill(null)
              .map((_, index) => (
                <th
                  key={index}
                  className="border bg-gray-50 px-4 py-2 text-center"
                >
                  {tournaments[index] ? (
                    <button
                      type="button"
                      onClick={() => setSelectedTournament(tournaments[index])}
                      title="Zobrazit tabulku turnaje"
                      className="text-blue-600 hover:text-blue-800 hover:underline font-medium"
                    >
                      {tournaments[index].date}
                    </button>
                  ) : (
                    ""
                  )}
                </th>
              ))}
            <th className="border bg-gray-50 px-4 py-2 text-center min-width-140">
              Účast
            </th>
            <th className="border bg-gray-50 px-4 py-2 text-center max-width-80">
              ⌀
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedResults.map((result: StandingsRow, index) => (
            <tr key={index} className="hover:bg-gray-100">
              <td className="border bg-gray-300 px-2 py-1 w-48 min-w-48 max-w-48 font-bold text-gray-600">
                {result.playerName}
              </td>
              <td className="border bg-gray-100 px-2 py-1 text-center w-24 min-w-24 max-w-24 font-bold text-gray-600">
                {result.placementPoints}
              </td>
              {result.results
                .concat(Array(10 - result.results.length).fill(null))
                .map((points, index) => (
                  <td
                    key={index}
                    className={`w-10 min-w-10 max-w-10 border ${
                      points !== null && !isNaN(points)
                        ? "bg-white"
                        : "bg-gray-50"
                    } px-4 py-2 text-center`}
                  >
                    {points !== null && !isNaN(points) ? points : ""}
                  </td>
                ))}
              <td className="border bg-gray-50 px-2 py-1 text-center border-l-4 border-double">
                <div className="w-full bg-gray-200 rounded-full dark:bg-gray-700">
                  <div
                    className={`${
                      result.attendance > 0
                        ? getColorByPercentage(result.attendance)
                        : ""
                    } text-xs font-medium text-white text-center p-0.5 leading-none rounded-full min-width-140 whitespace-nowrap`}
                    style={{ width: `${result.attendance}%` }}
                  >
                    {result.attendance >= 0 ? `${result.attendance} %` : ""}
                  </div>
                </div>
              </td>
              <td className="border bg-gray-50 px-2 py-1 text-center max-width-80">
                {result.pointsPerVisit > 0
                  ? result.pointsPerVisit.toFixed(2)
                  : ""}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Tabulka archivovaného turnaje – pouze pro čtení */}
      {selectedTournament && (
        <TournamentDetailModal
          tournament={selectedTournament}
          allPlayers={players}
          onClose={() => setSelectedTournament(null)}
          onDelete={() => handleDeleteTournament(selectedTournament)}
          deleting={deletingId === selectedTournament.id}
        />
      )}
    </div>
  );
};

export default Championship;
